var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.522 44.5217H489.739V489.739H44.522V44.5217Z",
    fill: "#F35325"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M534.261 44.5217H979.478V489.739H534.261V44.5217Z",
    fill: "#81BC06"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.522 534.261H489.739V979.478H44.522V534.261Z",
    fill: "#05A6F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M534.261 534.261H979.478V979.478H534.261V534.261Z",
    fill: "#FFBA08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftLogo);
export default __webpack_public_path__ + "static/media/Microsoft_Logo.5b61a467638e48af47fd0b269bafe75e.svg";
export { ForwardRef as ReactComponent };